export enum Sentiment {
  POSITIVE = 1,
  NEGATIVE = -1,
  NEUTRAL = 0,
}
